import { render, staticRenderFns } from "./AssociationDialogAdd.vue?vue&type=template&id=347a9987&scoped=true"
import script from "./AssociationDialogAdd.vue?vue&type=script&lang=ts"
export * from "./AssociationDialogAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a9987",
  null
  
)

export default component.exports